import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcuerdoPagoService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getAcuerdoPago(filter:any){
    return this.http.get(`${this.baserApiUrl}acuerdo-pago?${filter}`,)
  }


  getListaAcuerdoPago(filter:any){
    return this.http.get(`${this.baserApiUrl}acuerdo-pago/lista?${filter}`,)
  }
  getAcuerdoPagoPendienteAprobacion(filter:any){
    return this.http.get(`${this.baserApiUrl}acuerdo-pago/por-aprobar${filter}`,)
  }

  aprobarAcuerdo(data:any){
    return this.http.put(`${this.baserApiUrl}acuerdo-pago`,data)
  }

  addAcuerdoPago(data:any){
    return this.http.post(`${this.baserApiUrl}acuerdo-pago`,data)
  }

  deleteAcuerdoPago(params: any){
    return this.http.delete(`${ this.baserApiUrl }acuerdo-pago`,{params: params} )
  }
}